import { gql } from "@apollo/client";
import { createQuery } from "@mostrans/web-components/helpers/graphqlHelpers";

const GET_DIVISION = gql`
  query GetMasterDivision {
    getMasterDivision {
      data {
        id
        division
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getMasterDivision = createQuery({
    query: GET_DIVISION,
    defaultValue: [],
    initialVariables: {},
    selector: "getMasterDivision.data",
    responseSelector: "getMasterDivision.response"
})